/**
 * 供应商 接口的统一出口
 */
import axios from "../http"; // 导入http中创建的axios实例
import qs from "qs"; // 根据需求是否导入qs模块，把请求字段直接映射过来

const index = {
  // 供应商收入列表
  income(params) {
    return axios.get("/home/sellerincome/data", { params: params });
  },
  // 商铺中心商品列表
  centerGoods(params) {
    return axios.get("/home/sellercenter/goods", { params: params });
  },
  // 下架商品
  drop(params) {
    return axios.post("/home/goods/drop", qs.stringify(params));
  },
  // 上架商品
  on(params) {
    return axios.post("/home/goods/on", qs.stringify(params));
  },
  // 店铺设置头像
  thumb(params) {
    return axios.post("/home/seller/thumb", qs.stringify(params));
  },
  // 设置邮费
  fare(params) {
    return axios.post("/home/trad/fare", qs.stringify(params));
  },
  // 匠人订单列表
  order(params) {
    return axios.post("/home/b2c/merorderlist", qs.stringify(params));
  },
  // 拉取发票列表
  fapiaoList(params) {
    return axios.get("/home/saleInvoices/list", { params: params });
  },
  // 关闭订单
  closeOrder(params) {
    return axios.get("/home/b2c/merdelorder", { params: params });
  },
  // 查询匠人的代理商和城市合伙人
  getAgentsAndPartners(params) {
    return axios.get("/home/tradesman/getAgentsAndPartners", {
      params: params,
    });
  },
  // 园区类型
  getTradesmanPark(params) {
    return axios.get("/home/user/park", { params: params });
  },
  // 供应商详情
  sellerInfo(params) {
    return axios.get("/home/seller/info", { params: params });
  },
};

// 导出接口
export default index;
